export const RADIO_OPTIONS = [
  {
    label: 'List',
    value: 'false'
  },
  {
    label: 'Table',
    value: 'true'
  }
];
